import React from 'react';
import Grid from '@material-ui/core/Grid';
import { ClassNameMap } from '@material-ui/styles';

interface KPILabelProps {
    parentClasses: ClassNameMap,
    backgroundColor: string,
    labelText: string
}

const KPILabel: React.FC<KPILabelProps> = ({
    parentClasses,
    backgroundColor,
    labelText
}) => {
    return (
        <>
            <Grid item xs={8} className={parentClasses.kpiLabel} style={{ backgroundColor: backgroundColor }}>
                <span className={parentClasses.kpiLabelText}>{labelText}</span>
            </Grid>
        </>
    );
}

export default KPILabel;

